import { Layout } from '@components/Layout';
import PermissionGate from '@components/upercut-permissions/PermissionGate';
import BlogCreateForm from '@modules/blog/components/BlogCreateForm';
import BlogList from '@modules/blog/components/BlogList';
import { Container } from '@mui/material';
import { Route, Routes } from 'react-router-dom';

const BlogPage = () => {
    return (
        <Layout
            breadcrumbs={[
                { label: 'Tableau de bord', href: '/', value: 'dashboard' },
                { label: 'Articles de blog', href: '/blog', value: 'blog' },
                { label: 'Créer un article', href: '/blog/create', value: 'create' },
                { label: 'Modifier un article', href: '/blog/:id/edit', value: 'edit' },
            ]}
            heading="Articles de blog"
        >
            <Routes>
                <Route
                    path="/"
                    element={
                        <PermissionGate permission="content:read">
                            <BlogList />
                        </PermissionGate>
                    }
                />
                <Route
                    path="/create"
                    element={
                        <PermissionGate permission="content:create">
                            <BlogCreateForm />
                        </PermissionGate>
                    }
                />
                <Route
                    path="/:id/edit"
                    element={
                        <PermissionGate permission="content:update">
                            <BlogCreateForm />
                        </PermissionGate>
                    }
                />
            </Routes>
        </Layout>
    );
};


export default BlogPage;
